<template>
  <div :class="isMeunOpenFlag ? 'open' : ''">
    <span
      id="menuOpenIcon"
      class="menu_icon"
      @click="clickMeunBtn(isMeunOpenFlag)"
    >
      <i></i>
    </span>
    <ul class="meun_list_ul" :style="{ height: `${allMeunCeilHeightVw}vw` }">
      <li class="meun_ceil" v-for="item in childrenList" :key="item.id">
        <span class="meun_ceil_title" v-text="item.title"></span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'three_hori_menu',
  props: {
    childrenList: {
      type: Array,
      default: () => {
        return []
      },
    },
  },
  data() {
    return {
      uiDpi: 2,
      clientWidth: 0,
      isMeunOpenFlag: false,
      meunCeilHeightPx: 80, // meunCeilHeightPx: UI像素 dpi:2
    }
  },
  created() {
    this.clientWidth = window.innerWidth
      ? window.innerWidth
      : window.screen.width
      ? window.screen.width
      : 375
  },
  computed: {
    px2vw() {
      // clientWidth: 单倍像素值
      return Math.ceil((1 / (this.clientWidth * this.uiDpi)) * 100 * 100) / 100
    },
    allMeunCeilHeightVw() {
      // 20: 菜单底部留的空白
      return this.isMeunOpenFlag
        ? this.childrenList.length * this.meunCeilHeightPx * this.px2vw +
            20 * this.px2vw
        : 0
    },
  },
  methods: {
    clickMeunBtn(flag) {
      console.debug(flag)
      this.isMeunOpenFlag = !flag
    },
  },
}
</script>

<style lang="scss" scoped>
.menu_icon {
  display: block;
  position: relative;
  width: 32px;
  height: 32px;
  padding: 14px 0 10px;
}
.menu_icon i,
.menu_icon::before,
.menu_icon::after {
  background-color: #fff;
}
.menu_icon i,
.menu_icon::before,
.menu_icon::after {
  display: block;
  width: 100%;
  height: 4px;
  background-color: #333;
  border-radius: 2px;
}
.menu_icon::before {
  top: 0;
}
.menu_icon::after {
  top: 28px;
}
.menu_icon::before,
.menu_icon::after {
  position: absolute;
  left: 0;
  z-index: 2;
  content: '\20';
  -webkit-transform: rotate(0deg);
  -moz-transform: rotate(0deg);
  -o-transform: rotate(0deg);
  transform: rotate(0deg);
  -webkit-transition: all 0.2s linear;
  -moz-transition: all 0.2s linear;
  -o-transition: all 0.2s linear;
  transition: all 0.2s linear;
}

.open .menu_icon::before,
.open .menu_icon::after {
  top: 16px;
}
.open .menu_icon::before {
  -webkit-transform: rotate(45deg);
  -moz-transform: rotate(45deg);
  -o-transform: rotate(45deg);
  transform: rotate(45deg);
}
.open .menu_icon::after {
  -webkit-transform: rotate(-45deg);
  -moz-transform: rotate(-45deg);
  -o-transform: rotate(-45deg);
  transform: rotate(-45deg);
}
.open .menu_icon::before,
.open .menu_icon::after {
  -webkit-transform-origin: (50%, 50%);
  -moz-transform-origin: (50%, 50%);
  -o-transform-origin: (50%, 50%);
  transform-origin: (50%, 50%);
  -webkit-transition: transform 0.2s linear;
  -moz-transition: transform 0.2s linear;
  -o-transition: transform 0.2s linear;
  transition: transform 0.2s linear;
}
.open .menu_icon i {
  background-color: transparent;
}

.open .meun_list_ul {
  overflow-y: auto;
}
.meun_list_ul {
  position: fixed;
  top: 128px;
  left: 0;
  z-index: 10;
  width: 100%;
  height: 0;
  overflow-y: hidden;
  background-color: #902430;
  -webkit-transition: height 0.2s ease-in-out;
  -moz-transition: height 0.2s ease-in-out;
  -o-transition: height 0.2s ease-in-out;
  transition: height 0.2s ease-in-out;
  box-shadow: 3px 3px 10px 5px rgba(48, 3, 8, 0.15);
  .meun_ceil {
    width: 100%;
    height: 80px;
    padding: 0 20px;
    .meun_ceil_title {
      display: block;
      font-size: 16px;
      line-height: 80px;
      color: #fff;
      text-align: center;
      font-weight: bold;
    }
  }
}
</style>
